import React, { PureComponent } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { withRouter } from "react-router-dom";
// import ProductGallery from '../../../../components/catalog/ProductGallery';
// import ProductTabs from './ProductTabs';
// import StarIcon from 'mdi-react/StarIcon';
// import StarOutlineIcon from 'mdi-react/StarOutlineIcon';
import { connect } from 'react-redux';
import "video-react/dist/video-react.css";
import { Player } from "video-react";
import $ from 'jquery';
import DataLoader from '../../../app/DataLoader';
// import { signout } from '../../../redux/actions/userActions';
import TypeformView from '../TypeformView';
import uuid from 'uuid';

class VideoCardCurrentMonth extends PureComponent {
  state = {
    categoryIndex: 0,
    isActive: true,
    hoverColor: true,
    bgColr: "white-bg",
    loading: true,
    loaded: false,
    updateForm: true,
    forms: []
  }
  scrollContent(direction) {
    const step = 370;

    $("#card-content").animate({
      scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
    });
  }

  setUpdate = (title, active) => {
    this.setState({ updateForm: (title !== active) })
  }

  selectNewCatagory(category) {
    this.setState({ categoryIndex: category });
  }
  componentDidMount() {
    $(document).bind("contextmenu", function (e) {
      return false;
    });

    let forms 
    if(["prod"].includes(process.env.REACT_APP_ENV)){
      forms = [
        {
          name: 'Security Awareness Quiz',
          url: `https://postured.typeform.com/to/VVEKKvni#`,
          description: 'Step 2'
        }
      ]
    }
    else{
      forms = [
        {
          name: 'Security Awareness Quiz',
          url: `https://postured.typeform.com/to/kY9mMtbn#`,
          description: 'Step 2'
        }
      ]      
    }


    this.setState({ forms: forms })
  }

  componentWillUnmount() {
    $(document).unbind("contextmenu")
  }
  render() {
    const { currentVideo } = this.props;
    return (
      <Col md={12} lg={12}>
        <button
          className="btn btn-secondary"
          onClick={() => {
            this.props.history.push("/app/training/security");
          }}
          style={{
            float: "left"
          }}
        >
          {" "}
          {"<< Back To Training"}
        </button>
        {currentVideo ? (
          <React.Fragment>
            <Card>
              <CardBody>
                <div className="video-card">
                  <Player
                    playsInline
                    poster={currentVideo.thumbnail}
                    src={currentVideo.video}
                    onClick={e => {
                      console.log("click");
                    }}
                  />
                  {/* <h5 className="video_title"> {currentVideo.title} </h5>
                  <p className="video_time"> {currentVideo.time} </p> */}
                  {/* <p className="video_description"> {currentVideo.description} </p> */}
                </div>
                <DataLoader>
                  <div className="comp-assessment">
                    {
                      this.state.forms.map((category, idx) => {
                        return <div key={uuid()}>
                            <TypeformView
                            categoryIndex={this.state.categoryIndex}
                            i={idx}
                            url={`${category.url}&email=${this.props.user.email.replace('+','%2B')}` +
                              `&tenantname=${this.props.tenant ? this.props.tenant.companyName : ""}`}
                              frameworkName="monthlyquiz"
                              email={this.props.user.email}
                              month="March-2024"
                            />
                        </div>
                      }
                      )
                    }
                  </div >
                </DataLoader>
              </CardBody>
            </Card>

          </React.Fragment>
        ) : null}
      </Col>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    tenant: state.auth.tenant,
    enabledFrameworks: state.controlsData.enabledFrameworks,
    dataLoaded: !state.controlsData.loading,
    sidebar: state.sidebar
  }
}

export default connect(mapStateToProps)(withRouter(VideoCardCurrentMonth))




// WEBPACK FOOTER //
// ./src/components/training/components/VideoCardCurrentMonth.js